// removed by extract-text-webpack-plugin
module.exports = {"transContainer":"bjBz_wGbxg9XT2qBrWy4q","summaryContainer":"_2U298bKepnKQov0lvbDlK0","summary":"zk4xsSNNsNMfcmfrOSqBh","field":"_3a0t4MuvWHhU-Onj-ZHSDs","label":"_1ebJ_u5aQVGKJDSP6Ry-Rx","input":"zzgARoeBLTTwtjTF-BcSm"};


//////////////////
// WEBPACK FOOTER
// ./components/office/finances/FinancesTransactions.scss
// module id = 1620
// module chunks = 0